export const getDomainKeySelect = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];
  const domain = hostname.split(".")[1];

  // return "facilittapromotora";

  if (domain === "larpromotora") return "larpromotora";

  if (domain === "benisolutions") return "benisolutions";

  if (subdomain === "login" && domain === "solidapromotora")
    return "solidapromotora";

  return subdomain;
};
